<script setup>
import {computed, useSlots} from "vue";

const props = defineProps({
    hightlightOnHover: {
        type: Boolean,
        required: false,
        default: true
    },
    compact: {
        type: Boolean,
        required: false,
        default: false
    }
})

const slots = useSlots();

const listItemClasses = computed(() => {
    let classes = [];

    if (props.compact === true) {
        classes.push('py-2 px-3');
    } else {
        classes.push('p-4');
    }

    return classes;
})

</script>

<template>
    <li
        :class="hightlightOnHover ? '' : ''"
    >
        <div
            class="flex flex-col md:flex-row md:justify-between"
            :class="listItemClasses"
        >
            <div
                v-if="slots.status"
            >
                <slot name="status" />
            </div>
            <div class="block w-full">
                <div
                    v-if="slots.title"
                    class="font-medium text-gray-900 truncate"
                >
                    <slot name="title" />
                </div>
                <slot />
            </div>
            <div class="flex justify-end space-x-1 md:flex-col-reverse md:items-end">
                <slot name="actions" />
            </div>
        </div>
        <slot name="chin" />
    </li>
</template>

<style scoped>

</style>
